import React from 'react'
import './Servicedetail.css'
import helmetimg from './helmet.jpg'
function Servicedetail() {
  return (
    <div>
        <div class="responsive-container-block bigContainer">
  <div class="responsive-container-block Container bottomContainer">
    <div class="ultimateImg">
      <img class="mainImg" src={helmetimg}/>
      <div class="purpleBox">
        <p class="purpleText">
        "Connecting aspirations across horizons, forging innovative solutions together."
        </p>
        <img class="stars" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/mp5.svg"/>
      </div>
    </div>
    <div class="allText bottomText">
      <p class="text-blk headingText">
        Services
      </p>
      <p class="text-blk subHeadingText">
      We stand out as a prominent provider of manpower solutions
      </p>
      <p class="text-blk description">
      Renowned as a leading manpower supply firm in India, our expertise spans across various industries. Proficiency in specialized skills is pivotal for each task's professional execution.
      <br /> Our services cater to a diverse spectrum of industries.we understand the significance of specific skills required across industries. Every job demands expertise and experience for professional fulfillment. Our services extend to various industries, encompassing
      </p>
    
   
    </div>
  </div>
</div>
    </div>
  )
}

export default Servicedetail
